import { InjectionToken } from '@angular/core';

export const VERSION_MANAGER_API_TOKEN = new InjectionToken('VersionManagerApiToken');
